// src/pages/fourd/Project4DPage.jsx
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// ✅ BIM 전용 트리 컴포넌트 사용
import BimFileTree from "../../components/common/fourd/BimFileTree";
import ThreeViewerWithTimeline from "../../components/viewer/viewer3d/ThreeViewerWithTimeline";
import ThreeViewer from "../../components/viewer/viewer3d/ThreeViewer";
import { getProjectWeather } from "../../api/project";

const Project4DPage = () => {
  const { id: projectId } = useParams();
  const [selectedFourD, setSelectedFourD] = useState(null); // { gltfUrl, name }
  const [viewMode, setViewMode] = useState("simulation"); // simulation | model
  const [weatherData, setWeatherData] = useState(null);

  useEffect(() => {
    if (projectId) {
        getProjectWeather(projectId).then(data => {
            if (data && data.forecast && data.forecast.length > 0) {
                // 가장 최근(현재) 예보의 PTY(강수), SKY(하늘) 값 추출
                setWeatherData(data.forecast[0].values);
            }
        });
    }
  }, [projectId]);

  return (
    <div className="flex flex-col h-full bg-gray-50">
      {/* 상단 헤더 영역 */}
      <div className="px-6 py-4 flex items-center justify-between border-b bg-white shadow-sm shrink-0">
        <div>
          <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
            🏗️ 4D 시뮬레이션
          </h2>
          <p className="mt-1 text-xs text-gray-500">
            프로젝트 ID: <span className="font-medium text-blue-600">{projectId}</span> | glTF 모델을 선택하여 시뮬레이션을 확인하세요.
          </p>
        </div>
        
        {/* 보기 모드 탭 */}
        <div className="flex bg-gray-100 p-1 rounded-lg">
          <button
            type="button"
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all ${
              viewMode === "simulation"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setViewMode("simulation")}
          >
            시뮬레이션
          </button>
          <button
            type="button"
            className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all ${
              viewMode === "model"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setViewMode("model")}
          >
            모델 뷰어
          </button>
        </div>
      </div>

      {/* 메인 콘텐츠 영역 (Split Layout) */}
      <div className="flex-1 flex overflow-hidden p-4 gap-4">
        {/* 왼쪽: 파일 트리 */}
        <div className="w-[320px] shrink-0 h-full"> 
          <BimFileTree
            selectionMode="single"
            onPick={(file) => {
              setSelectedFourD({
                gltfUrl: file.gltf_file,
                name: file.name,
              });
            }}
            onFolderSelect={() => {}}
          />
        </div>

        {/* 오른쪽: 뷰어 */}
        <div className="flex-1 bg-white border rounded-xl shadow-sm overflow-hidden flex flex-col relative h-full">
           {selectedFourD ? (
              <>
                 <div className="absolute top-4 left-4 z-10 bg-white/80 backdrop-blur px-3 py-1.5 rounded-full shadow-sm text-sm font-medium text-gray-700 border">
                    📂 {selectedFourD.name}
                 </div>
                 {viewMode === "simulation" ? (
                    <ThreeViewerWithTimeline gltfUrl={selectedFourD.gltfUrl} weatherData={weatherData} projectId={projectId} />
                 ) : (
                    <ThreeViewer gltfUrl={selectedFourD.gltfUrl} weatherData={weatherData} />
                 )}
              </>
            ) : (
              <div className="flex-1 flex flex-col items-center justify-center text-gray-400">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                   <svg className="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" /></svg>
                </div>
                <p className="text-sm">좌측 트리에서 4D 모델 파일을 선택해주세요.</p>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Project4DPage;
